import { SVG } from '../SVG'

export const GoogleIcon = ({ style = {}, ...props }) => (
  <SVG
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...style }}
    {...props}
  >
    <path
      d='M32.2321 16.7948C32.2321 15.5043 32.125 14.5626 31.893 13.5859H16.8125V19.4108H25.6644C25.486 20.8583 24.5223 23.0383 22.3807 24.5032L22.3506 24.6982L27.1188 28.3079L27.4492 28.3401C30.4831 25.602 32.2321 21.5734 32.2321 16.7948'
      fill='#4285F4'
    />
    <path
      d='M16.8118 32.1424C21.1485 32.1424 24.7892 30.7471 27.4485 28.3405L22.3799 24.5036C21.0236 25.428 19.2032 26.0732 16.8118 26.0732C12.5643 26.0732 8.95923 23.3352 7.67413 19.5508L7.48577 19.5664L2.52773 23.316L2.46289 23.4921C5.10419 28.6194 10.5296 32.1424 16.8118 32.1424Z'
      fill='#34A853'
    />
    <path
      d='M7.67449 19.5507C7.3354 18.574 7.13916 17.5276 7.13916 16.4463C7.13916 15.365 7.3354 14.3187 7.65665 13.342L7.64766 13.134L2.6275 9.32422L2.46325 9.40056C1.37464 11.5283 0.75 13.9176 0.75 16.4463C0.75 18.9751 1.37464 21.3643 2.46325 23.492L7.67449 19.5507'
      fill='#FBBC05'
    />
    <path
      d='M16.8118 6.81904C19.8278 6.81904 21.8623 8.09214 23.0224 9.15605L27.5555 4.83093C24.7714 2.30216 21.1485 0.75 16.8118 0.75C10.5296 0.75 5.10419 4.27283 2.46289 9.40012L7.65629 13.3416C8.95922 9.55714 12.5642 6.81904 16.8118 6.81904'
      fill='#EB4335'
    />
  </SVG>
)

export default GoogleIcon
